
import {
  getAnalysisTypesGrouped,
} from '../services/analysisTypeService';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const useAnalysisTypes = () => {
  const queryClient = useQueryClient();

  const {
    data: analysisData = [],
    isLoading: loading,
    error: queryError,
  } = useQuery({
    queryKey: ['analysisTypes'],
    queryFn: getAnalysisTypesGrouped,
    staleTime: Infinity, // Analysis types change very rarely
  });

  const error = queryError ? "Impossible de charger la liste des examens" : null;

  return {
    analysisData,
    loading,
    error,
    reload: () => queryClient.invalidateQueries({ queryKey: ['analysisTypes'] }),
  };
};

// Fonction pour précharger les données - peut être appelée au démarrage de l'app
export const preloadAnalysisTypes = async (queryClient: any) => {
  return queryClient.prefetchQuery({
    queryKey: ['analysisTypes'],
    queryFn: getAnalysisTypesGrouped,
  });
};

